import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import ProtectedRoute from './auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import GeneratorPage from './pages/GeneratorPage';
import HistoryPage from './pages/HistoryPage';
import CreditsPage from './pages/CreditsPage';
import FavouritesPage from './pages/catalog/FavouritesPage';
import LibraryPage from './pages/LibraryPage';
import PublicSongPage from './pages/PublicSongPage';
import { AppShell } from './app-shell/AppShell';
import { AudienceTracker } from './audience/AudienceTracker';
import { GoogleAnalytics } from './audience/GoogleAnalytics';

/**
 * app.mixgenie.ai — the generator/library app. This bundle has no
 * catalog / lyric surface (that lives on dicelacancion.com's own
 * bundle) and no CONVERSION_ENABLED gate — auth, generator, credits
 * are always on because that's the whole point of this surface.
 *
 * AppShell is mounted ONCE as a layout route (via <Outlet />), not
 * inside every page component. If each page rendered its own
 * <AppShell>, tab-switching would unmount+remount the GlobalAudioPlayer
 * inside and reset any currently-playing track to 0:00. Hoisting it
 * here keeps the audio element and its state alive across navigation.
 *
 * Login / Register / Forgot / AuthCallback are outside the layout
 * because they render their own full-viewport dark backgrounds and
 * shouldn't show the app chrome.
 */
function AppShellLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AudienceTracker />
        <GoogleAnalytics />
        <Routes>
          {/* Unshelled auth routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />

          {/* Public share page — no auth, renders its own chrome. Recipients
              of a share link tap this, hear the song, and see the "Create
              your own" CTA. */}
          <Route path="/s/:jobId" element={<PublicSongPage />} />

          {/* Everything else lives inside a single, persistent AppShell */}
          <Route element={<AppShellLayout />}>
            <Route path="/generator" element={<ProtectedRoute><GeneratorPage /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
            <Route path="/songs" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
            <Route path="/credits" element={<ProtectedRoute><CreditsPage /></ProtectedRoute>} />
            <Route path="/favourites" element={<ProtectedRoute><FavouritesPage /></ProtectedRoute>} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/shared" element={<LibraryPage />} />
          </Route>

          <Route path="/" element={<Navigate to="/generator" replace />} />
          <Route path="*" element={<Navigate to="/generator" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
